import { useQuery } from "@tanstack/react-query";

import { productsQueryOptions } from "@/domains/products/factories/products-query-options";

export const useLabResults = () => {
  return useQuery({
    ...productsQueryOptions["lab-results"],
    staleTime: 1000 * 60 * 15,
  });
};
